var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputVideo',{attrs:{"id":_vm.id,"value":_vm.data},on:{"change":_vm.changeVideoData}})}
var staticRenderFns = []

export { render, staticRenderFns }